import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DayCheck } from '@qaroni-app/check/types/month-check';
import { DaySchedule } from '@qaroni-app/check/types/month-schedule';

@Component({
  selector: 'qaroni-check-details-hours',
  templateUrl: './check-details-hours.component.html',
  styleUrls: ['./check-details-hours.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CheckDetailsHoursComponent {
  readonly hours = input<number>(0);
  readonly scheduleTimeMonth = input<number>(0);
  readonly dayChecks = input<DayCheck[]>([]);
  readonly daySchedules = input<DaySchedule[]>([]);
  readonly monthName = input<string>('');
}
